// src/pages/Contact.jsx
import React, { useState } from 'react';
import { FaUser, FaEnvelope, FaBook, FaPaperPlane, FaMapMarkerAlt, FaPhone, FaClock } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    // Simulate form submission
    setTimeout(() => {
      console.log('Form submitted:', formData);
      setIsSubmitted(true);
      setIsLoading(false);
      setFormData({ name: '', email: '', subject: '', message: '' });
      
      // Reset success message after 5 seconds
      setTimeout(() => setIsSubmitted(false), 5000);
    }, 1500);
  };

  return (
    <div className="contact-page">
      <div className="contact-header">
        <h1>Contactez Notre École</h1>
        <p>Nous sommes là pour répondre à toutes vos questions sur nos programmes et admissions</p>
      </div>
      
      <div className="contact-container">
        <div className="contact-info-card">
          <div className="contact-info-section">
            <h2><span className="section-icon">✉️</span> Informations de Contact</h2>
            <div className="contact-detail">
              <div className="contact-icon"><FaMapMarkerAlt /></div>
              <div>
                <h3>Adresse</h3>
                <p>Sébikotane<br />Dakar, Sénégal</p>
              </div>
            </div>
            
            <div className="contact-detail">
              <div className="contact-icon"><FaPhone /></div>
              <div>
                <h3>Téléphone</h3>
                <p>+221 70 686 36 36</p>
              </div>
            </div>
            
            <div className="contact-detail">
              <div className="contact-icon"><FaEnvelope /></div>
              <div>
                <h3>Email</h3>
                <p>u2s.edu@gmail.com</p>
              </div>
            </div>
            
            <div className="contact-detail">
              <div className="contact-icon"><FaClock /></div>
              <div>
                <h3>Horaires</h3>
                <p>Lundi-Vendredi: 8h00 - 17h00<br />Samedi: 9h00 - 13h00</p>
              </div>
            </div>
          </div>
          
          <div className="contact-info-section">
            <h2><span className="section-icon">📍</span> Localisation</h2>
            <div className="map-container">
              <div className="map-placeholder">
              <button className="map-button" onClick={() => window.open('https://maps.app.goo.gl/kt1acac7NabdWXTy9', '_blank')}>
                <div className="map-overlay">
                  <div className="map-marker">
                    <div className="marker-pin"></div>
                    <div className="marker-label">Notre École</div>
                  </div>
                </div>
                </button>
              </div>
              <p className="map-instructions">Nous sommes situés à Sébikotane</p>
            </div>

          </div>
        </div>
        
        <div className="contact-form-card">
          <div className="form-header">
            <h2>Envoyez-nous un message</h2>
            <p>Remplissez le formulaire ci-dessous et notre équipe vous répondra dans les plus brefs délais</p>
          </div>
          
          {isSubmitted && (
            <div className="success-message">
              <div className="success-icon">✓</div>
              <div>
                <h3>Message envoyé avec succès!</h3>
                <p>Merci de nous avoir contactés. Nous vous répondrons dans les 24 heures.</p>
              </div>
            </div>
          )}
          
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label htmlFor="name">
                <FaUser className="input-icon" /> Nom Complet
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Votre nom complet"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">
                <FaEnvelope className="input-icon" /> Adresse Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="votre@email.com"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="subject">
                <FaBook className="input-icon" /> Sujet
              </label>
              <select
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              >
                <option value="" disabled hidden>Sélectionnez un sujet</option>
                <option value="admission">Demande d'admission</option>
                <option value="information">Demande d'information</option>
                <option value="visit">Demande de visite</option>
                <option value="partnership">Partenariat</option>
                <option value="other">Autre demande</option>
              </select>
            </div>
            
            <div className="form-group">
              <label htmlFor="message">Votre Message</label>
              <textarea
                id="message"
                name="message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
                placeholder="Écrivez votre message ici..."
              ></textarea>
            </div>
            
            <button 
              type="submit" 
              className={`submit-btn ${isLoading ? 'loading' : ''}`}
              disabled={isLoading}
            >
              {isLoading ? (
                <div className="spinner"></div>
              ) : (
                <>
                  <FaPaperPlane className="btn-icon" /> 
                  Envoyer le Message
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;